module.exports = __webpack_public_path__ + "static/img/a3.831c7930.png";